/*
  Louru: ilmaisen toimituksen palkki + "Sopii ostoksiisi" -suositukset (snippets/louru-free-shipping-bar.liquid, louru-fsb-card.liquid)
  sekä tuotesivun lisätuoteosion "Lisää koriin" -napit (snippets/louru-product-addons.liquid, .louru-addon-btn).

  Miksi erillinen tiedosto: Horizon päivittää ostoskorilaatikon sisällön morph-tekniikalla
  (Section Rendering API + DOMParser). Selain ei suorita morphatun HTML:n sisällä olevia
  inline-<script>-tageja, joten snippetin oma skripti ei koskaan käynnistynyt, kun kori
  täyttyi sivulla ollessa. Lisäksi kuuntelija oli sidottu yksittäiseen #fsb-container-
  elementtiin, joka korvautuu jokaisessa korin päivityksessä.

  Korjaus: skripti ladataan kerran jokaisella sivulla (cart-drawer.liquid ja snippet itse),
  ja klikkaukset kuunnellaan document-tasolla (event delegation), joten napit toimivat
  riippumatta siitä, milloin ja miten palkki on renderöity.
*/
(function () {
  if (window.__louruFsbInit) return;
  window.__louruFsbInit = true;

  function container() {
    return document.getElementById('fsb-container');
  }

  function formatMoney(cents, locale) {
    return (cents / 100).toLocaleString(locale === 'en' ? 'en-FI' : 'fi-FI', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  // 10/2026: t-paidat (Printify) 100 €, muut tuotteet 200 €. Shopify laskee rajan kummallekin toimitusprofiilille erikseen.
  function isTshirt(item) {
    return item.vendor === 'Printify' || /^t-?shirt$/i.test(item.product_type || '');
  }

  function splitTotals(cart) {
    let ts = 0, other = 0;
    (cart.items || []).forEach(function (i) {
      const v = typeof i.final_line_price === 'number' ? i.final_line_price : i.line_price;
      if (isTshirt(i)) ts += v; else other += v;
    });
    return { ts: ts, other: other };
  }

  function updateBar(cart) {
    const el = container();
    if (!el) return;
    const tsThreshold = parseInt(el.dataset.thresholdTshirt || '10000', 10);
    const otherThreshold = parseInt(el.dataset.thresholdOther || el.dataset.threshold || '20000', 10);
    const t = splitTotals(cart);
    const tsOnly = t.other === 0 && t.ts > 0;
    const threshold = tsOnly ? tsThreshold : otherThreshold;
    const totalCents = tsOnly ? t.ts : t.other;
    el.dataset.threshold = String(threshold);
    el.dataset.primaryTotal = String(totalCents);
    const mode = tsOnly ? 'ts' : t.ts > 0 ? 'mixed' : 'other';
    el.dataset.mode = mode;
    const sfx = mode === 'ts' ? 'Ts' : mode === 'mixed' ? 'Mixed' : '';
    const msgAlmost = (sfx && el.dataset['msgAlmost' + sfx]) || el.dataset.msgAlmost || '';
    const msgReached = (sfx && el.dataset['msgReached' + sfx]) || el.dataset.msgReached || '';
    const noteEl = el.querySelector('.fsb-note');
    const noteText = el.dataset['note' + (sfx || 'Other')];
    if (noteEl) { noteEl.textContent = noteText || ''; noteEl.hidden = !noteText; }

    const tsLine = el.querySelector('.fsb-ts-line');
    if (tsLine) {
      if (!tsOnly && t.ts > 0) {
        const tsRemaining = tsThreshold - t.ts;
        tsLine.hidden = false;
        if (tsRemaining <= 0) {
          tsLine.className = 'fsb-ts-line fsb-success';
          tsLine.textContent = el.dataset.msgTsReached || '';
        } else {
          tsLine.className = 'fsb-ts-line';
          tsLine.textContent = (el.dataset.msgTsAlmost || '').split('{amount}').join(formatMoney(tsRemaining, el.dataset.locale));
        }
      } else {
        tsLine.hidden = true;
      }
    }

    const msgEl = el.querySelector('.fsb-message');
    const fillEl = el.querySelector('.fsb-bar-fill');
    if (!msgEl || !fillEl || !threshold) return;

    const remaining = Math.max(threshold - totalCents, 0);
    fillEl.style.width = Math.min((totalCents / threshold) * 100, 100) + '%';

    if (totalCents >= threshold) {
      msgEl.className = 'fsb-message fsb-success';
      msgEl.textContent = msgReached;
      const recsEl = document.getElementById('fsb-recs');
      if (recsEl) recsEl.style.display = 'none';
    } else {
      msgEl.className = 'fsb-message';
      const strong = document.createElement('strong');
      strong.textContent = formatMoney(remaining, el.dataset.locale);
      const parts = msgAlmost.split('{amount}');
      msgEl.textContent = '';
      msgEl.append(parts[0] || '', strong, parts[1] || '');
    }
  }

  async function refresh(delayMs) {
    if (delayMs) await new Promise((r) => setTimeout(r, delayMs));
    if (!container()) return;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      updateBar(cart);
      await rankRecs(cart);
    } catch (e) {
      console.warn('FSB: päivitys epäonnistui', e);
    }
  }

  /* ---------- Korin tuotteisiin sopivat suositukset ---------- */

  // Shopifyn suositukset tuotteittain välimuistiin, ettei samoja haeta joka korin päivityksellä.
  const recCache = new Map();

  function shopMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function sizedImage(url) {
    if (!url) return '';
    const u = url.startsWith('//') ? 'https:' + url : url;
    return u + (u.includes('?') ? '&' : '?') + 'width=160&height=160&crop=center';
  }

  async function fetchRecs(recsUrl, productId, intent) {
    const key = productId + ':' + intent;
    if (recCache.has(key)) return recCache.get(key);
    const p = fetch(recsUrl + '.json?product_id=' + productId + '&limit=10&intent=' + intent, {
      headers: { Accept: 'application/json' }
    })
      .then((r) => (r.ok ? r.json() : { products: [] }))
      .then((d) => d.products || [])
      .catch(() => []);
    recCache.set(key, p);
    return p;
  }

  function buildCard(p, tier, addBtn) {
    const variant = (p.variants || []).find((v) => v.available) || (p.variants || [])[0];
    if (!variant) return null;
    const card = document.createElement('div');
    card.className = 'fsb-rec-card';
    card.dataset.productId = String(p.id);
    card.dataset.price = String(variant.price);
    card.dataset.tier = String(tier);
    card.dataset.tshirt = p.vendor === 'Printify' || /^t-?shirt$/i.test(p.type || p.product_type || '') ? '1' : '0';

    const img = p.featured_image || (p.images && p.images[0]);
    if (img) {
      const im = document.createElement('img');
      im.loading = 'lazy';
      im.src = sizedImage(typeof img === 'string' ? img : img.src);
      im.alt = p.title;
      im.className = 'fsb-rec-img';
      im.width = 80;
      im.height = 80;
      card.appendChild(im);
    }
    const info = document.createElement('div');
    info.className = 'fsb-rec-info';
    const title = document.createElement('p');
    title.className = 'fsb-rec-title';
    const a = document.createElement('a');
    a.href = p.url;
    a.textContent = p.title.length > 40 ? p.title.slice(0, 37) + '...' : p.title;
    title.appendChild(a);
    const price = document.createElement('p');
    price.className = 'fsb-rec-price';
    price.textContent = shopMoney(variant.price);
    const unlocks = document.createElement('p');
    unlocks.className = 'fsb-rec-unlocks';
    unlocks.hidden = true;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fsb-rec-btn';
    btn.dataset.variantId = String(variant.id);
    btn.textContent = addBtn;
    info.append(title, price, unlocks, btn);
    card.appendChild(info);
    return card;
  }

  // Pienempi arvo = parempi. Täyttää puuttuvan summan ilman suurta ylitystä -> 0..0.1,
  // jää vajaaksi -> 1..2 (mitä lähempänä sen parempi), ylittää reilusti -> 2+.
  function priceFit(price, remaining) {
    const over = price - remaining;
    const allowance = Math.max(1500, remaining * 0.5);
    if (over >= 0 && over <= allowance) return over / (allowance * 10);
    if (over < 0) return 1 + -over / remaining;
    return 2 + over / remaining;
  }

  let rankToken = 0;
  async function rankRecs(cart) {
    const el = container();
    const grid = el && el.querySelector('.fsb-recs-grid');
    if (!el || !grid) return;
    const threshold = parseInt(el.dataset.threshold, 10);
    const primaryTotal = el.dataset.primaryTotal !== undefined ? parseInt(el.dataset.primaryTotal, 10) : cart.total_price;
    const remaining = threshold - primaryTotal;
    if (remaining <= 0) { grid.dataset.ranked = '1'; return; }

    const token = ++rankToken;
    const inCart = new Set(cart.items.map((i) => String(i.product_id)));
    const recsUrl = el.dataset.recsUrl || '/recommendations/products';
    const addBtn = el.dataset.addBtn || 'Lisää koriin';

    // Shopifyn suositukset korin kalleimmille (enintään 3) tuotteille
    const cartProducts = [...new Map(cart.items.map((i) => [i.product_id, i])).values()]
      .sort((a, b) => b.final_line_price - a.final_line_price)
      .slice(0, 3)
      .map((i) => i.product_id);
    const lists = await Promise.all(
      // Vain 'complementary' (lisätuotteet). 'related' antaa korvaavia tuotteita (esim. toisia kameroita), ei lisätuotteita.
      cartProducts.map((pid) => fetchRecs(recsUrl, pid, 'complementary').then((ps) => ps.map((p) => [p, 2])))
    );
    if (token !== rankToken || !document.contains(grid)) return; // kori ehti muuttua

    const present = new Set([...grid.querySelectorAll('.fsb-rec-card')].map((c) => c.dataset.productId));
    for (const [p, tier] of lists.flat()) {
      const id = String(p.id);
      if (!p.available || inCart.has(id) || present.has(id)) continue;
      const card = buildCard(p, tier, addBtn);
      if (card) {
        grid.appendChild(card);
        present.add(id);
      }
    }

    // Järjestys: pakolliset lisätuotteet (taso 0) ensin, sitten korin tuotteisiin sopivat (1–2)
    // hinnan sopivuuden mukaan, lopuksi valikoiman täyte (9) hinnan sopivuuden mukaan.
    const cards = [...grid.querySelectorAll('.fsb-rec-card')].filter((c) => !inCart.has(c.dataset.productId));
    // 10/2026: kortti avaa ilmaisen toimituksen vain, jos se kuuluu samaan toimitusryhmään kuin korin raja:
    // pelkkiä t-paitoja -> vain t-paidat; muuten -> vain muut kuin t-paidat. Muut kortit järjestetään viimeisiksi.
    const tsMode = el.dataset.mode === 'ts';
    const matches = (c) => (c.dataset.tshirt === '1') === tsMode;
    const group = (t) => (t === 0 ? 0 : t < 9 ? 1 : 2);
    cards.sort((a, b) => {
      const ma = matches(a), mb = matches(b);
      if (ma !== mb) return ma ? -1 : 1;
      const ta = Number(a.dataset.tier), tb = Number(b.dataset.tier);
      const ga = group(ta), gb = group(tb);
      if (ga !== gb) return ga - gb;
      const fa = priceFit(Number(a.dataset.price), remaining);
      const fb = priceFit(Number(b.dataset.price), remaining);
      if (Math.abs(fa - fb) > 1e-9) return fa - fb;
      return ta - tb;
    });
    cards.forEach((c) => {
      c.hidden = false;
      grid.appendChild(c);
      const u = c.querySelector('.fsb-rec-unlocks');
      if (u) {
        const unlocks = matches(c) && Number(c.dataset.price) >= remaining;
        u.hidden = !unlocks;
        u.textContent = unlocks ? el.dataset.unlocks || '' : '';
      }
    });
    // Jo korissa olevat piiloon ja jonon loppuun (CSS näyttää 3 ensimmäistä korttia)
    grid.querySelectorAll('.fsb-rec-card').forEach((c) => {
      if (inCart.has(c.dataset.productId)) { c.hidden = true; grid.appendChild(c); }
    });
    grid.dataset.ranked = '1';
  }

  // Korilaatikko morphataan uudelleen joka päivityksessä: kun uusi palkki ilmestyy DOMiin, järjestetään se.
  // Nopeus 10/2026: tarkkaillaan vain ostoskorilaatikkoa (#cart-drawer) ja palkin omaa osiota, ei koko dokumenttia,
  // ja reagoidaan vain, kun palkki tai suositusruudukko lisätään tai ruudukon data-ranked-merkintä muuttuu.
  // Aiemmin jokainen sivun DOM-muutos (sovellukset, karusellit, chat) ajoi tarkistuksen.
  let observerTimer = null;
  function isFsbNode(n) {
    return (
      n.nodeType === 1 &&
      (n.id === 'fsb-container' ||
        n.classList.contains('fsb-recs-grid') ||
        !!n.querySelector('#fsb-container, .fsb-recs-grid'))
    );
  }
  const observer = new MutationObserver(function (mutations) {
    let relevant = false;
    for (const m of mutations) {
      if (m.type === 'attributes') relevant = true;
      else for (const n of m.addedNodes) if (isFsbNode(n)) { relevant = true; break; }
      if (relevant) break;
    }
    if (!relevant) return;
    const grid = document.querySelector('#fsb-container .fsb-recs-grid');
    if (!grid || grid.dataset.ranked === '1') return;
    clearTimeout(observerTimer);
    observerTimer = setTimeout(function () { refresh(0); }, 50);
  });
  function observeCart() {
    const targets = new Set();
    const drawer = document.getElementById('cart-drawer');
    if (drawer) targets.add(drawer);
    const fsb = container();
    if (fsb && !(drawer && drawer.contains(fsb))) {
      const section = fsb.closest('.shopify-section') || fsb.parentElement;
      if (section) targets.add(section);
    }
    targets.forEach(function (t) {
      observer.observe(t, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-ranked'] });
    });
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest && e.target.closest('.fsb-rec-btn, .louru-addon-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const el = btn.closest('#fsb-container');
    const txtAdd = btn.textContent;
    const txtAdding = btn.dataset.adding || (el && el.dataset.addingBtn) || txtAdd;
    const txtAdded = btn.dataset.added || (el && el.dataset.addedBtn) || txtAdd;

    btn.disabled = true;
    btn.textContent = txtAdding;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      btn.textContent = txtAdded;
      btn.classList.add('added');
      // Sivun uudelleenlataus päivittää korin, laskurin ja palkin varmasti oikein.
      setTimeout(function () { window.location.reload(); }, 600);
    } catch (err) {
      console.warn('FSB: lisäys koriin epäonnistui', err);
      btn.disabled = false;
      btn.textContent = txtAdd;
    }
  });

  document.addEventListener('cart:updated', () => refresh(800));
  document.addEventListener('cart:refresh', () => refresh(800));
  document.addEventListener('cart-drawer:open', () => refresh(0));

  // Päivitä palkki, kun teema itse muuttaa koria (määrän muutos, poisto, lisäys tuotesivulta).
  const origFetch = window.fetch;
  window.fetch = function () {
    const args = arguments;
    const promise = origFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      promise.then(function () { refresh(600); }).catch(function () {});
    }
    return promise;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { observeCart(); refresh(0); });
  } else {
    observeCart();
    refresh(0);
  }
})();
